import React from "react";
import PropTypes from "prop-types";
import { CSVLink } from "react-csv";
import textContent from "react-addons-text-content";
import styles from "./TableOptions.scss";

export const TableExportButton = props => {
  const headers = props.tableColumns.map(column => {
    return {
      label: column.headerText,
      key: column.accessor
    };
  });

  //Format data to print the inner text of react elements
  const data = [];

  _.forEach(props.tableData, row => {
    const clonedRow = { ...row };

    _.forEach(row, (field, index) => {
      //is react element ? return inner text : return itself (string)
      clonedRow[index] = _.isObject(field) ? textContent(field) : field;
    });

    data.push(clonedRow);
  });

  return (
    <CSVLink
      className={styles.icon}
      data={data}
      headers={headers}
      filename="exported-table.csv"
    >
      {props.tableData.length > 0 ? "Export as CSV" : "Loading CSV Data..."}
    </CSVLink>
  );
};

TableExportButton.propTypes = {
  tableColumns: PropTypes.array.isRequired
};



// WEBPACK FOOTER //
// ./src/components/common/table/TableExportButton.js